import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toHandlers as _toHandlers, vModelSelect as _vModelSelect, mergeProps as _mergeProps, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-component-name"]
const _hoisted_2 = { class: "o-form__item" }
const _hoisted_3 = { class: "o-select__wrap" }
const _hoisted_4 = ["id", "name", "placeholder", "required", "multiple", "autocomplete"]
const _hoisted_5 = {
  value: '',
  disabled: "",
  selected: ""
}
const _hoisted_6 = ["value", "innerHTML"]
const _hoisted_7 = { class: "o-form__validation" }
const _hoisted_8 = { class: "o-form__validation__required" }
const _hoisted_9 = { class: "o-form__validation__error" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_inputlabel = _resolveComponent("inputlabel")

  return (!$props.disabledIDs.includes($props.field.id))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "data-component-name": _ctx.$options.name,
        class: _normalizeClass((!$props.field.inputClass) ? 'o-grid-12' : $props.field.inputClass)
      }, [
        _createVNode(_component_inputlabel, { field: $props.field }, null, 8 /* PROPS */, ["field"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("select", _mergeProps({
              class: ["o-select", { 'readonly': $props.field.inputReadonly === true }]
            }, _toHandlers($data.readOnlyHandlers, true), {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($props.field.value) = $event)),
              id: 'input-' + $props.field.id,
              name: $props.field.inputName,
              placeholder: $props.field.inputPlaceholder,
              required: ($props.field.inputRequired === true) ? 'required' : false,
              multiple: ($props.field.inputChoicesMultiple === true) ? 'multiple' : false,
              autocomplete: ($props.field.inputAutocomplete && $props.field.inputAutocomplete != '' && $props.field.inputAutocomplete != 'querystring' && $props.field.inputAutocomplete != 'reactivevalue' && $props.field.inputAutocomplete != 'cookie') ? $props.field.inputAutocomplete : false
            }), [
              _createElementVNode("option", _hoisted_5, _toDisplayString(($props.field.inputPlaceholder !== null && $props.field.inputPlaceholder != '') ? $props.field.inputPlaceholder : _ctx._t('Choisir')), 1 /* TEXT */),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.field.inputChoices, (choice, ci) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: 'cb-'+ci+'-'+$props.field.id,
                  value: (String(choice.value).trim() != '') ? choice.value : choice.text,
                  innerHTML: (String(choice.text).trim() != '') ? String(choice.text) : String(choice.value)
                }, null, 8 /* PROPS */, _hoisted_6))
              }), 128 /* KEYED_FRAGMENT */))
            ], 16 /* FULL_PROPS */, _hoisted_4), [
              [_vModelSelect, $props.field.value]
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx._t('Ce champ est obligatoire.')), 1 /* TEXT */),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx._t('Ce champ est obligatoire.')), 1 /* TEXT */)
            ])
          ])
        ])
      ], 10 /* CLASS, PROPS */, _hoisted_1))
    : _createCommentVNode("v-if", true)
}